module.exports = __webpack_public_path__ + "img/lcbg.2c75582b.png";